export const MEDIA_TYPES = {
  SPARK_VIDEOS: 'SparkVideos',
}
